import React from "react";

import styled from "@emotion/styled";
import { Switch } from "antd";
import { Link } from "react-router-dom";

import VeroGoOverrideModal from "./VeroGoOverrideModal";

export const SettingsLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  &:hover {
    color: inherit;
    text-decoration: underline;
  }
`;

export const GreenSwitch = styled(Switch)`
  &.ant-switch-checked {
    background-color: #059669;
    &:hover,
    &:focus {
      background-color: #047857;
    }
  }
`;

export type VeroGoOverrideModalContext = {
  title: string;
  subtitle: string;
  nowState: "on" | "off";
  nowRelationship: "inherited" | "custom";
  afterState: "on" | "off";
  afterRelationship: "inherited" | "custom";
  infoText: React.ReactNode;
  primaryButtonLabel: string;
  secondaryButtonLabel: string;
  primaryValue: string;
  secondaryValue: string;
};

export const openVeroGoOverrideDialog = async (
  openModalDialog: any,
  context: VeroGoOverrideModalContext
) => {
  // @ts-ignore afterClose exists at runtime (ModalManager.js)
  const { afterClose } = openModalDialog(VeroGoOverrideModal, context);
  return afterClose;
};
